// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1AAsI","footer":"ChangeClinic_footer__2Vs8D"};